"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Alert_1 = __importDefault(require("@mui/material/Alert"));
// A variant of the "Alert" component that spans across the screen and centers its content.
function AlertBanner(_a) {
    var alertProps = __rest(_a, []);
    return ((0, jsx_runtime_1.jsx)(Alert_1.default, Object.assign({}, alertProps, { sx: Object.assign({ borderRadius: 0, justifyContent: "center" }, alertProps.sx) })));
}
exports.default = AlertBanner;
